import React, {useEffect, useRef} from 'react';
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";

const AnimateOnce = ({ children, styleFrom, styleTo }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  const target = useRef();

  useEffect(() => {
    if (inView) {
      gsap.to(target.current, { ...styleTo });
    }

    return () => {
      target.current = null;
    }
  }, [inView]);

  return (
    <div
      ref={(el) => { target.current = el; ref(el)}}
      style={styleFrom}
    >
      {children}
    </div>
  );
};

export default AnimateOnce;